<template>
  <div class="create-project">
    <div class="content mb10">
      <div>
        <h3 class="common-title mb5">上传职位说明书（JD）,没有JD可直接点击下一步</h3>
        <h3 class="mb15" style="font-size:16px;">可选择以下几种填写方式:</h3>
        <div class="display-flex mb10">
          <div style="flex:1">
            <div class="tip-box mb15">
              <h3 class="mb10">方法一：附件上传</h3>
              <p class="common-tips">1、支持上传Word、Excel、PDF、图片等</p>
              <p class="common-tips">2、优先Word文档，系统能够解析word文字内容，其它格式仅能以附件展示</p>
            </div>
            <el-upload
              ref="upload"
              :action="uploadUrl"
              :on-success="uploadSuccess"
              :on-error="handleError"
              :on-progress="onProgress"
              drag
              with-credentials
            >
              <i class="el-icon-upload" style="margin-top:95px" />
              <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
              <!-- <div slot="tip" class="el-upload__tip">
                {{ errors.length > 0 ? '胜败乃兵家常事，少侠请从新来过' : '' }}
              </div> -->
              <!-- <div v-for="(err, index) in errors" slot="tip" :key="err.file" class="el-upload__tip">
                <span class="error-name">{{ err.file }}</span> <span class="error-msg">{{ err.message }}</span>
                <span class="error luxun" @click="removeError(index)">无视它</span>
              </div> -->
            </el-upload>
          </div>
          <div style="flex:1">
            <div class="tip-box mb15">
              <h3 class="mb10">方法二：在线填写</h3>
              <p class="common-tips">1、文字填写系统会自动提取关键词</p>
              <p class="common-tips">2、智能解析有误差，请人为校对！</p>
            </div>
            <div>
              <div class="mb15">岗位职责：</div>
              <el-input
                v-model="copyProject.岗位职责"
                class="mb15"
                type="textarea"
                :rows="5"
                :placeholder="
                  `案例：
1. 独立寻找和筛选有发展潜力和投资价值的项目机会；
2. 独立进行市场和行业研究；
3. 独立构建项目财务模型，进行估值和回报分析；
4. 协调外部资源实施项目尽职调查，出具尽职调查报告；`
                "
              >
              </el-input>
              <div class="mb15">岗位要求：</div>
              <el-input
                v-model="copyProject.岗位要求"
                type="textarea"
                :rows="6"
                :placeholder="
                  `案例：
1. 学历：重点院校本科或硕士以上，MBA优先；
2. 专业：金融、经济、管理或理工类专业,具备经济和理工科复合教育背景优先；
3. 3年以上VC/PE/IB或者互联网企业战投相关工作经验，对泛互联网、TMT领域有深入行业洞见；
4. 英语读写熟练，有一定的口语交流能力。`
                "
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="handle-buttons">
      <el-button type="primary" size="mini" @click="confirm">下一步</el-button>
    </div>
  </div>
</template>

<script>
// import {

// } from ../components/AddProject
import { parseTemplateText } from '../../constant/utils'

export default {
  components: {},
  props: {
    project: { type: Object, dafault: () => ({}) },
  },
  data() {
    return {
      fields: ['岗位职责', '岗位要求'],
      uploadUrl: `${window.host}/uploads`,
      errors: [],
      textarea: '',
      copyProject: {},
    }
  },
  watch: {
    project: {
      handler(newValue, oldValue) {
        this.copyProject = newValue
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    async uploadSuccess(response, file, fileList) {
      const res = response[0]
      this.parseTemplate(res)
      const projectId = this.copyProject._id
      const type = '其他'
      if (res.originalname.includes('项目信息模板.docx')) return
      try {
        await app.service('project').insertProjectFile([Object.assign(res, { type, projectId })])
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async parseTemplate(file) {
      if (!file.originalname.match(/\.(docx|doc)$/)) return
      const res = await app.service('project').parseDocx(file)
      const json = parseTemplateText(res)
      this.fields.forEach(field => {
        if (json[field]) this.$set(this.copyProject, field, json[field])
      })
      console.log(this.copyProject)
    },
    handleError(err, file, fileList) {
      this.errors.push({ file: file.name, message: err.message })
      this.onError(err, file, fileList)
    },
    onProgress() {},
    removeError(index) {
      this.errors.splice(index, 1)
    },
    confirm() {
      this.$emit('next')
    },
  },
}
</script>
<style>
.create-project .el-upload-dragger {
  height: 300px;
  width: 400px;
}
</style>
